<div class="week-plan-layout">
    <div class="week-plan-content">
        <div
            class="week-plan-content"
            cdkDropList
            [id]="CalendarDropListId"
            cdkDropListSortingDisabled
            [cdkDropListData]="null"
            (cdkDropListDropped)="onCalendarDrop($event)"
        >
<ejs-schedule
    #scheduleObj
    width="100%"
    height="100%"
    [selectedDate]="SelectedDate"
    [eventSettings]="EventSettings$ | async"
    dateFormat="dd.MM.yyyy"
    [firstDayOfWeek]="1"
    (eventRendered)="onEventRendered($event)"
    (cellClick)="onCellClick($event)"
    (dragStart)="onDragStart($event)"
    (dragStop)="onDragStop($event)"
    (resizeStart)="onResizeStart($event)"
    (resizeStop)="onResizeStop($event)"
    eventDragArea=".week-plan-layout"
    cssClass="week-plan-schedule"
    (actionComplete)="onActionComplete($event)"
    (popupOpen)="onPopupOpen($event)"
>
    <ng-template #eventTemplate let-data>
        <app-event-card
            [EventId]="data.Id"
            [Expandable]="false"
            [Compact]="isCompactEvent(data)"
            [EventInWeekPlan]="true"
            style="display: block; width: 100%; height: inherit;"
        ></app-event-card>
    </ng-template>
    <e-views>
        <e-view
            option="Week"
            startHour="07:00"
            endHour="22:00"
            [timeScale]="{ enable: true, interval: 60, slotCount: 2 }"
        >

        </e-view>
    </e-views>



</ejs-schedule>
    </div>
    </div>

    <div class="tasks-board-content">
        <div class="drop-veil" [class.active]="IsDraggingCalendarEvent"></div>
        <mat-card>
            <div class="tasks-board-toolbar">
                <button app-round-button [matTooltip]="SearchBarActive && !SearchForm.value ? 'Ausblenden' : 'Suche'"  [attr.aria-label]="SearchBarActive && !SearchForm.value ? 'Ausblenden' : 'Suche'" style="margin: .5rem" (click)="SearchButtonClicked()">
                    <fa-icon [icon]="SearchBarActive && !SearchForm.value ? 'times' : 'search'"></fa-icon>
                </button>
                <button
                    app-round-button
                    [matBadge]="TaskBoardFilterAmount$ | async"
                    [matBadgeHidden]="!(TaskBoardFilterAmount$ | async)"
                    [matBadgeOverlap]="true"
                    matTooltip="Filter"
                    (click)="filter.Open()"
                    style="margin-right: .5rem"
                >
                    <fa-icon icon="filter"></fa-icon>
                </button>
                <button app-round-button matTooltip="Sortieren" style="margin-right: .5rem" aria-label="Sortieren" [matMenuTriggerFor]="sortMenu">
                    <fa-icon icon="sort"></fa-icon>
                </button>
                <button style="vertical-align: text-bottom;" app-round-button matTooltip="neue Aufgabe"  aria-label="neue Aufgabe" (click)="OpenAddTaskDialog()">
                    <app-double-icon style="" Icon="clipboard-check" Icon2="plus"></app-double-icon>
                </button>


                <div *ngIf="SearchBarActive">
                    <mat-form-field color="accent" class="search-field">
                        <input
                            type="text"
                            placeholder="Suche"
                            [formControl]="SearchForm"
                            matInput
                            #input
                        />

                        <button
                            type="button"
                            class="clear-search"
                            (click)="SearchForm.setValue('')"
                            *ngIf="SearchForm.value"
                            mat-icon-button
                            aria-label="Suche löschen"
                        >
                            <fa-icon icon="times"></fa-icon>
                        </button>
                    </mat-form-field>
                </div>

            </div>

            <div class="scrollable-tasks-area">
                <div class="user-select-list" *ngIf="AllUsers$ | async as allUsers">
                    <ng-container *ngIf="UserSelectionContext$ | async as ctx">
                        <h4 class="user-select-title">Mitarbeiter</h4>
                        <label
                            class="user-select-item"
                            *ngFor="let user of allUsers"
                            [style.background]="isUserSelected(user.Id, ctx) ? ctx.ColorByUserId[user.Id] : null"
                        >
                            <mat-checkbox
                                color="primary"
                                [checked]="isUserSelected(user.Id, ctx)"
                                [disabled]="isUserSelectionDisabled(user.Id, ctx)"
                                (change)="toggleUserSelection(user.Id)"
                            >
                                {{ user.DisplayName }}
                            </mat-checkbox>
                        </label>
                    </ng-container>
                </div>
            <app-tasks-board
                [ExternalConnectedDropListIds]="[CalendarDropListId]"
                [SelectedBoardColumns]="selectedBoardColumns"
                [Filter]="taskBoardFilter$ | async"
                [Search]="SearchForm.value"
                [Sort]="TaskBoardSort"
                [openedFromWeekPlan]="true"
                [showCompleted]="ShowCompleted$ | async"
                [showReleased]="ShowReleased$ | async"
                [showOnHold]="ShowOnHold$ | async"
                (FileClicked)="OpenFile($event)"
                [ShowNewButton]="false"
                [DragPreviewBackground]="DragPreviewBackground$ | async"
            >
            </app-tasks-board>
            </div>
            <app-filter-card #filter [Settings]="TaskBoardFilterSettings$ | async" [Values]="TaskBoardFilterValues$ | async" (ValuesChange)="TaskBoardFilterValues$.next($event)"> </app-filter-card>
        </mat-card>
    </div>
    </div>



    <mat-menu #sortMenu="matMenu">
        <button mat-menu-item (click)="TaskBoardSort = {sortBy: 'endDate', direction: 'asc'}"><fa-icon icon="chevron-up"></fa-icon> Frist</button>
        <button mat-menu-item (click)="TaskBoardSort = {sortBy: 'endDate', direction: 'dsc'}"><fa-icon icon="chevron-down"></fa-icon> Frist</button>
        <button mat-menu-item (click)="TaskBoardSort = {sortBy: 'priority', direction: 'asc'}"><fa-icon icon="chevron-up"></fa-icon> Priorität</button>
        <button mat-menu-item (click)="TaskBoardSort = {sortBy: 'priority', direction: 'dsc'}"><fa-icon icon="chevron-down"></fa-icon> Priorität</button>
    </mat-menu>

